import Banner from "./Banner";
import { useSelector } from "react-redux";
import Navbar from "layout/navbar/Navbar";
import React, { useEffect, useState } from "react";
import ProjectSearchBar from "shared/ProjectSearchBar";

const ProjectPageSections = () => {
  const { projects } = useSelector((state) => state.project);
  const [result, setResult] = useState(projects);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div>
      <Navbar />
      <ProjectSearchBar setResult={setResult} />
      <Banner result={result} />
    </div>
  );
};

export default ProjectPageSections;
